import React from "react";

import "./about.scss";
// import Product from "../../Components/Product";
import Discount from "../../Components/Discount";
import Blog from "../../Components/Blog";

import man from "../../Assets/images/man.png";

const AboutPage = () => {
  return (
    <>
      <div className="page">
        <div>
          <h2>About us</h2>
          <h5>
            <i className="fas fa-home fa-1x"></i> Home / About
          </h5>
        </div>
      </div>
      <div className="about section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" data-aos="fade-right">
              <img src={man} alt="about man" width="80%" />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex align-items-center" data-aos="fade-left">
              <div>
                <p style={{ fontFamily: "satisfy, cursive" }}>About us</p>
                <h3>WE SERVE BEST QUALITY PRODUCT</h3>
                <p >
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit. Unde
                  tempora obcaecati culpa? Rerum at velit eligendi ratione
                  molestiae suscipit modi sunt praesentium magnam? Explicabo
                  alias unde debitis officiis odio modi, saepe ratione odit sed,
                  ad ipsam sequi nostrum dicta. Temporibus expedita hic minima
                  ab consequatur similique quasi vero itaque est?
                </p>
                <button className="shop-btn">Shop now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Discount />
      <Blog />
    </>
  );
};

export default AboutPage;
